<template>
  <div :class="['chat-message relative', message.sender]">
    <template v-if="message.type === 'text'">
      <!-- <p v-if="!message.speak" class="text-sm font-normal leading-snug">
        {{ message.text }}
      </p> -->
      <p class="text-xs sm:text-sm font-normal leading-snug">
        {{ message.text }}
      </p>

      <!-- // audio visualizer component -->
      <!-- <div class="block">
        <MessagePlayer
          @toggleVideo="toggleVideo"
          :isSpeakText="isSpeakText"
          :message="message.text"
          :messageObj="message"
        />
      </div> -->

      <!-- <button
        v-show="!isPlaying"
        @click="playSpeech(message.text)"
        type="button"
        class="bg-gray-300 hover:bg-gray-400 text-gray-700 shadow-md font-semibold capitalize rounded-full py-2 px-2 absolute -top-2 -right-2"
      >
        <Icon icon="heroicons:speaker-wave-16-solid" />
      </button>
      <button
        v-show="isPlaying"
        @click="pauseSpeech"
        type="button"
        class="bg-gray-300 hover:bg-gray-400 text-gray-700 shadow-md font-semibold capitalize rounded-full py-2 px-2 absolute -top-2 -right-2"
      >
        <Icon icon="heroicons:speaker-x-mark-20-solid" />
      </button> -->
    </template>

    <template v-if="message.type === 'audio'">
      <audio :src="message.audioUrl" controls></audio>
    </template>
  </div>
</template>

<script>
// import MessagePlayer from "./MessagePlayer.vue";

// import { Icon } from "@iconify/vue";

export default {
  components: {
    // MessagePlayer
  },
  props: {
    message: Object,
    // isSpeakText: Boolean,
  },
  data() {
    return {
      isLoading: false,
      isPlaying: false,
      greetingSpeech: new window.SpeechSynthesisUtterance(),
      selectedVoice: 0,
      synth: window.speechSynthesis,
    };
  },
  mounted() {
    // wait for voices to load
    // I can't get FF to work without calling this first
    // Chrome works on the onvoiceschanged function
    this.voiceList = this.synth.getVoices();

    if (this.voiceList.length) {
      this.isLoading = false;
    }

    this.synth.onvoiceschanged = () => {
      this.voiceList = this.synth.getVoices();
      // give a bit of delay to show loading screen
      // just for the sake of it, I suppose. Not the best reason
      setTimeout(() => {
        this.isLoading = false;
      }, 800);
    };

    this.listenForSpeechEvents();
  },
  methods: {
    listenForSpeechEvents() {
      this.greetingSpeech.onstart = () => {
        this.isLoading = true;
        this.isPlaying = true;
      };

      this.greetingSpeech.onend = () => {
        this.isLoading = false;
        this.isPlaying = false;
        this.synth.cancel(); // Stop the speech immediately
        this.$emit("stopMessage");
      };
    },
    playSpeech(message) {
      this.$emit("playMessage");
      this.greetingSpeech.text = message;
      this.greetingSpeech.voice = this.voiceList[this.selectedVoice];
      this.synth.speak(this.greetingSpeech);
    },
    pauseSpeech() {
      this.$emit("stopMessage");
      this.synth.cancel(); // Stop the speech immediately
      this.isPlaying = false;
    },
    toggleVideo(action) {
      switch (action) {
        case "play":
          this.$emit("stopMessage");

          break;

        case "pause":
          this.$emit("playMessage");
          break;

        default:
          this.$emit("playMessage");
          break;
      }
    },
  },
};
</script>

<style scoped>
.chat-message {
  @apply p-4 mx-2 rounded-xl mb-5 max-w-[95%] w-full;
}
.chat-message.user {
  @apply bg-[rgba(187,128,231,0.2)] text-black self-end rounded-br-none;
}
.chat-message.bot {
  @apply bg-white text-black self-start rounded-bl-none;
}
</style>
